import { styled } from 'styled-components'
import { Button } from '@enterprise-ui/canvas-ui-react'

export const ProfileContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  padding: 10px 22px 0;
`

export const UserAvatarContainer = styled.div`
  align-items: center;
  background-color: #272727;
  border-radius: 50%;
  display: flex;
  height: 140px;
  justify-content: center;
  width: 140px;
`

export const UserInitials = styled.p`
  color: white;
  font-size: 35px;
`

export const UserPreferredName = styled.p`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
`

export const ProfileActionContainer = styled.div`
  background-color: #272727;
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ProfileActionItem = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
  align-items: center;
  display: flex;
  gap: 10px;
  height: 71px;
  padding-left: 10px;
`

export const ProfileActionButton = styled(Button)`
  border-radius: 8px !important;
  background-color: #34383c;
  border-color: transparent !important;
  color: #bdbdbd;
`

export const MigrationNotice = styled.div`
  align-items: center;
  background-color: #272727;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-left: 4px solid #e0342b;
  border-radius: 16px;
  color: #ffffff;
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  width: 100%;
`

export const MigrationNoticeIcon = styled.img`
  border-radius: 10px;
  flex-shrink: 0;
  height: 44px;
  width: 44px;
`

export const MigrationNoticeBody = styled.div`
  flex: 1;
  min-width: 0;
`

export const MigrationNoticeTitle = styled.p`
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 2px;
`

export const MigrationNoticeText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
`

export const MigrationNoticeLearnMore = styled.button`
  background: none;
  border: none;
  color: #f28b82;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin-top: 6px;
  padding: 0;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid rgba(242, 139, 130, 0.6);
    border-radius: 4px;
  }
`

export const MigrationNoticeWarning = styled(MigrationNotice)`
  border-left-color: #f57c00;
`

export const MigrationNoticeLearnMoreWarning = styled(MigrationNoticeLearnMore)`
  color: #ffb74d;

  &:focus-visible {
    outline-color: rgba(255, 183, 77, 0.6);
  }
`

export const MigrationDetailsWrapper = styled.div`
  width: 100%;
`

export const BottomSheetOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;

  @media (min-width: 768px) {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 24px;
  }
`

export const BottomSheet = styled.div`
  animation: slideUp 0.3s ease-out;
  background-color: #1a1a1a;
  border-radius: 20px 20px 0 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  max-height: 90vh;
  position: absolute;
  right: 0;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @media (min-width: 768px) {
    animation: fadeScaleIn 0.2s ease-out;
    border-radius: 16px;
    bottom: auto;
    left: auto;
    max-height: 85vh;
    max-width: 560px;
    position: relative;
    right: auto;
    width: 100%;

    @keyframes fadeScaleIn {
      from {
        opacity: 0;
        transform: scale(0.96);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
`

export const BottomSheetHandle = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  cursor: grab;
  flex-shrink: 0;
  height: 4px;
  margin: 12px auto 4px;
  width: 40px;

  @media (min-width: 768px) {
    display: none;
  }
`

export const BottomSheetHeader = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 12px 20px 8px;

  @media (min-width: 768px) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding: 16px 24px;
  }
`

export const BottomSheetTitle = styled.p`
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`

export const BottomSheetCloseButton = styled.button`
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.4);
  }
`

export const BottomSheetBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 0 env(safe-area-inset-bottom, 16px);
  -webkit-overflow-scrolling: touch;
`
